import * as msg from '../../../../node_modules/console-tags.js/src/console-tags.js'

const Watermark = () => {
  const bgImg = 'https://dinkbit.s3.amazonaws.com/img/firmas/dinkbit.png'

  console.log(
    '%c ',
    'background: url(' + bgImg + ') no-repeat center/150px; color: white; padding: 25px 75px'
  )

  msg.custom('¡Hacemos cosas', 'increíbles!', '#427dfc')
}

export default Watermark()
